export default function HeroResponsable() {
  return (
    <section className="relative min-h-[440px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=calm%20serene%20abstract%20background%20with%20soft%20teal%20and%20dark%20navy%20gradient%2C%20gentle%20light%20rays%2C%20peaceful%20minimalist%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20smooth%20bokeh%20particles%2C%20wide%20cinematic%20format%2C%20professional%20wellness%20aesthetic&width=1440&height=440&seq=jr-hero-001&orientation=landscape"
          alt="Juego Responsable"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080a0f]/96 via-[#080a0f]/85 to-[#080a0f]/70"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#080a0f] via-transparent to-transparent"></div>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 py-24 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#06b6d4]/10 border border-[#06b6d4]/20 mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-[#06b6d4]"></div>
            <span className="text-[#06b6d4] text-xs font-semibold uppercase tracking-widest">Apostar con responsabilidad</span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Syne', sans-serif" }}>
            Juego <span className="text-[#06b6d4]">Responsable</span>
          </h1>
          <p className="text-[#a8b2c1] text-lg leading-relaxed mb-6">
            Las apuestas deben ser entretenimiento, no una fuente de estrés o problemas. Aquí encontrarás herramientas, recursos y ayuda para mantener el control.
          </p>

          <div className="flex items-center gap-4 p-4 bg-[#06b6d4]/10 border border-[#06b6d4]/20 rounded-xl">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#06b6d4]/20 flex-shrink-0">
              <i className="ri-phone-line text-[#06b6d4] text-xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-lg">900 200 225</p>
              <p className="text-[#a8b2c1] text-sm">FEJAR · Línea de ayuda gratuita y confidencial · 24h/7 días</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
